import React, { useEffect, useRef, useState } from 'react';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

export default function PaymentReturn({ mode, onDone, onGrant }) {
  const [state, setState] = useState(mode === 'cancel' ? 'cancel' : 'checking');
  const [grant, setGrant] = useState({ coins: 0, keys: 0, items: [] });
  const attempts = useRef(0);

  useEffect(() => {
    if (mode === 'cancel') return;
    const params = new URLSearchParams(window.location.search);
    const sid = params.get('session_id');
    if (!sid) { setState('error'); return; }

    let timer;
    const backoff = [1000, 1500, 2000, 2500, 3000, 3500, 4000, 4000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000];
    const claim = async () => {
      try {
        const r = await fetch(API + '/payments/claim', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sid }),
        });
        const d = await r.json();
        if (d.granted) {
          const g = { coins: d.coins || 0, keys: d.keys || 0, items: d.items || [] };
          onGrant(g);
          // drop from local pending queue
          try {
            const pend = JSON.parse(localStorage.getItem('so_pending') || '[]').filter((s) => s !== sid);
            localStorage.setItem('so_pending', JSON.stringify(pend));
          } catch {}
          setGrant(g); setState('success'); return;
        }
        if (d.already_credited) { setState('success'); return; }
        if (d.paid === false && ['expired', 'failed'].includes(d.payment_status)) { setState('error'); return; }
      } catch (e) { /* keep trying */ }
      if (attempts.current >= backoff.length) { setState('timeout'); return; }
      timer = setTimeout(claim, backoff[attempts.current]);
      attempts.current += 1;
    };
    claim();
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [mode]);

  const done = () => { window.history.replaceState({}, '', '/'); onDone(); };

  return (
    <div className="so-menu" data-testid="payment-return">
      <div className="so-menu-bg" />
      <div className="so-customize" style={{ textAlign: 'center', alignItems: 'center' }}>
        {state === 'checking' && (<><div className="so-spinner" /><h2>Confirming payment…</h2><p className="so-store-sub">Hang tight, unlocking your rewards.</p></>)}
        {state === 'success' && (<>
          <div style={{ fontSize: '3.5rem' }}>🎉</div>
          <h2 data-testid="payment-success">Payment Complete!</h2>
          <div className="so-pay-grants">
            {grant.coins > 0 && <span className="so-grant">🪙 +{grant.coins.toLocaleString()} coins</span>}
            {grant.keys > 0 && <span className="so-grant">🔑 +{grant.keys} keycards</span>}
            {(grant.items || []).map((g, i) => <span key={i} className="so-grant exclusive">🎁 {g.id}</span>)}
          </div>
          <button className="so-btn-play" onClick={done} data-testid="payment-done">Back to Menu</button>
        </>)}
        {state === 'cancel' && (<>
          <div style={{ fontSize: '3.5rem' }}>🛒</div>
          <h2 data-testid="payment-cancel">Checkout Cancelled</h2>
          <p className="so-store-sub">No worries — no charge was made.</p>
          <button className="so-btn-play" onClick={done} data-testid="payment-done">Back to Menu</button>
        </>)}
        {(state === 'error' || state === 'timeout') && (<>
          <div style={{ fontSize: '3.5rem' }}>⚠️</div>
          <h2>{state === 'timeout' ? 'Still processing' : 'Something went wrong'}</h2>
          <p className="so-store-sub">If you were charged, your rewards will appear shortly.</p>
          <button className="so-btn-play" onClick={done} data-testid="payment-done">Back to Menu</button>
        </>)}
      </div>
    </div>
  );
}
